<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="CreateCompany"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :color="$config.company.color"
    :dialogName="resourceTitle"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :name="formName"
      schema="CreateCompany"
      :id="formId"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetCompanyGeneral
        :item="item"
        display-fetch-by-tax-number
        @input="evh_5534025912102772_input($event, {})"
      >
      </FieldsetCompanyGeneral>
      <div
        v-if="item.addresses && item.addresses.length"
      >
        <ItpText
          uppercase
          :text="'Address'|pgettext('CreateCompany')"
        >
        </ItpText>
        <HR>
        </HR>
        <FieldsetAddress
          :address="item.addresses[0]"
        >
        </FieldsetAddress>
      </div>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="messages.submitButtonText[role]"
      type="submit"
      :form="forms[formName]"
      :spinning="actions.create.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.create.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class CreateCompany extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: String,
  })
  role!: string;

  @Watch('role')
  onRole(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("role")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  messages!: any;
  item!: any;

  async $$load_item() {
    return this.$fn.schemaDefaults('CreateCompany', {
      emails: null,
      role: this.role,
      relation: this.role === 'company' ? 'na' : 'customer'
    })
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['messages', 'item', 'formName', 'formId', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          create: {
            own: this.$fn.pgettext("Company|Header", "New own company"),
            partner: this.$fn.pgettext("Company|Header", "New partner"),
          }
          ,
          resourceTitle: {
            own: this.$fn.pgettext("Company|ResourceTitle", "Company"),
            partner: this.$fn.pgettext("Company|ResourceTitle", "Partner"),
          }
          ,
          submitButtonText: {
            own: this.$fn.pgettext("Button", "Create company"),
            partner: this.$fn.pgettext("Button", "Create partner"),
          }
          ,
        }
        ,
        item: null,
        formName: "company",
        formId: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get resourceTitle() {
    if (this.loaded) {

      return this.messages.resourceTitle[this.role]
    }
    return null;
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.messages.create[this.role],
        icon: this.$config.company.icons[this.role],
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3040_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3040, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeComponent_3046_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1040167445267876_closeComponent_3046, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async act_1040167445267876_navigate_3048_getActionArgs($event: actions.ActionEvent): Promise<actions.NavigateActionArgs> {
    // parameterResolver name=act_1040167445267876_navigate_3048, alias=undefined
    return {
      location: {
        name: "app.company",
        params: {
          id: $event.data.response.data.id,
        }
        ,
      }
      ,
    }
  }

  async act_1040167445267876_reloadSlickgrid_3050_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_1040167445267876_reloadSlickgrid_3050, alias=undefined
    return {
      grid: "companies",
    }
  }

  async act_1040167445267876_request_3044_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_1040167445267876_request_3044, alias=create
    return {
      operation: "create_company",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_setData_3052_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_5534025912102772_setData_3052, alias=undefined
    return {
      path: "item",
      value: $event.data,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_5534025912102772_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_input.executeFromDOM(this, event, scope);
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3040: actions.CloseModalAction;
    evh_7315092382398562_close_3039: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3042: actions.CloseModalAction;
    evh_2248226175642056_close_3041: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeComponent_3046: actions.CloseComponentAction;
    evh_1040167445267876_success_3045: actions.EventHandlerImpl;
    act_1040167445267876_navigate_3048: actions.NavigateAction;
    evh_1040167445267876_success_3047: actions.EventHandlerImpl;
    act_1040167445267876_reloadSlickgrid_3050: actions.ReloadSlickgridAction;
    evh_1040167445267876_success_3049: actions.EventHandlerImpl;
    act_1040167445267876_request_3044: actions.RequestAction;
    evh_1040167445267876_submit_3043: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_setData_3052: actions.SetDataAction;
    evh_5534025912102772_input_3051: actions.EventHandlerImpl;
    evh_5534025912102772_input: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_3054: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_3053: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3040 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3040_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3039 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3040,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3039],
      }
    );
    const act_2248226175642056_closeModal_3042 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3041 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3042,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3041],
      }
    );
    const act_1040167445267876_closeComponent_3046 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1040167445267876_closeComponent_3046_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3045 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeComponent_3046,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const act_1040167445267876_navigate_3048 = new actions.NavigateAction(
      {
        actionArgs: this.act_1040167445267876_navigate_3048_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3047 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_navigate_3048,
        event: "success",
        displayName: "navigate",
      }
    );
    const act_1040167445267876_reloadSlickgrid_3050 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_1040167445267876_reloadSlickgrid_3050_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3049 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_reloadSlickgrid_3050,
        event: "success",
        displayName: "reloadSlickgrid",
      }
    );
    const act_1040167445267876_request_3044 = new actions.RequestAction(
      {
        actionArgs: this.act_1040167445267876_request_3044_getActionArgs,
        displayName: "create",
        events: [evh_1040167445267876_success_3045, evh_1040167445267876_success_3047, evh_1040167445267876_success_3049],
      }
    );
    const evh_1040167445267876_submit_3043 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_request_3044,
        event: "submit",
        displayName: "create",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3043],
      }
    );
    const act_5534025912102772_setData_3052 = new actions.SetDataAction(
      {
        actionArgs: this.act_5534025912102772_setData_3052_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_input_3051 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_setData_3052,
        event: "input",
        displayName: "setData",
      }
    );
    const evh_5534025912102772_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_input_3051],
      }
    );
    const act_1419464017721962_closeComponent_3054 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3053 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_3054,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3053],
      }
    );
    return {
      act_7315092382398562_closeModal_3040,
      evh_7315092382398562_close_3039,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3042,
      evh_2248226175642056_close_3041,
      evh_2248226175642056_close,
      act_1040167445267876_closeComponent_3046,
      evh_1040167445267876_success_3045,
      act_1040167445267876_navigate_3048,
      evh_1040167445267876_success_3047,
      act_1040167445267876_reloadSlickgrid_3050,
      evh_1040167445267876_success_3049,
      act_1040167445267876_request_3044,
      evh_1040167445267876_submit_3043,
      evh_1040167445267876_submit,
      act_5534025912102772_setData_3052,
      evh_5534025912102772_input_3051,
      evh_5534025912102772_input,
      act_1419464017721962_closeComponent_3054,
      evh_1419464017721962_clickPreventStop_3053,
      evh_1419464017721962_clickPreventStop,
      create: act_1040167445267876_request_3044,
    }
  }
}

Vue.component("CreateCompany", CreateCompany);

</script>